module.exports = __webpack_public_path__ + "img/Pic_Text_PEFA.7c8ee17b.png";